module.exports = __webpack_public_path__ + "media/images/integration_logo_focco_delivery_dark-6b6b018422395cb9a1f1347f42342b18.svg";